import { TagTheme } from '@/components/Tag/theme';
import { tw } from '@/utils/tw';
import BaseArticleHeaderTheme from 'base/components/ArticleHeader/theme';

const { ContactUsLink } = BaseArticleHeaderTheme;

const Tag = tw.theme({
  extend: TagTheme,
  variants: {
    colors: {
      text: 'text-cherry-blossom-500',
    },
    variant: {
      text: 'uppercase',
    },
  },
});

const ArticleHeader = tw.theme({
  extend: BaseArticleHeaderTheme,
  variants: {
    variant: {
      second: {
        base: `mx-auto mb-5 w-full gap-3 md:max-w-cols-10 lg:max-w-cols-9`,
        bylines: `gap-2 text-gray-600 text-body-sm`,
        category: `order-5`,
        description: `text-preamble-sm sm:text-preamble`,
        headline: `text-headline-alternative-lg sm:text-headline-alternative-2xl`,
        media: `[&_img]:aspect-default [&_img]:object-cover`,
        tags: `order-1 col-span-2 flex`,
        date: `text-preheadline leading-snug text-gray-600`,
      },
    },
  },
  defaultVariants: {
    variant: 'second',
  },
});

export default Object.assign(ArticleHeader, { ContactUsLink, Tag });
